<template>
    <modal @closeModal="$emit('closePermitModal')">
        <div slot="header">
            <h4 class="modal-title">Apply for Permit</h4>
        </div>
        <div slot="body">
            <p>Select Year you want to apply for:</p>
            <div class="form-group" :class="{'has-danger': errors.has('year') }">
                <select class="form-control m-input" v-model="selectedYear" name="year" v-validate="'required'">
                    <option v-for="(year,key) in years" :key="key" :value="year">{{ year }}</option>
                </select>
                <small v-show="errors.has('year')" class="form-control-feedback">{{ errors.first('year') }}</small>
            </div>
        </div>
        <button type="button" slot="buttons" class="btn btn-success" :class="{ 'm-loader m-loader--light m-loader--right': loading }" @click="applyPermit">
            <i class="fa fa-check-circle-o"></i> Apply
        </button>
    </modal>
</template>
<script>
import Modal from "../../../Modal.vue";
import api from "../../../../api";
import helper from "../../../../helpers";

export default {
  name: "ApplyPermit",
  props: ["businessId"],
  data() {
    return {
      years: [],
      selectedYear: "",
      loading: false,
      token: this.$store.state.token || window.localStorage.getItem("token")
    };
  },
  components: {
    Modal
  },
  methods: {
    applyPermit() {
      this.$validator
        .validate("year", this.selectedYear)
        .then(valid => {
          if (valid) {
            this.toggleLoading();
            const txType = "apply-for-permit";
            let data = {
              token: this.token,
              businessId: this.businessId,
              year: this.selectedYear
            };
            api
              .request(txType, data)
              .then(response => {
                this.toggleLoading();
                if (response.data.status === "00") {                  
                  this.$emit("closePermitModal",response.data.invoices);
                  helper.successAlert(
                    "Permit application was successful. Please check your invoices."
                  );
                } else {
                  this.$emit("closePermitModal");
                  helper.errorAlert(response.data.message);
                }
              })
              .catch(error => {
                this.toggleLoading();
                this.$emit("closePermitModal");
                helper.errorAlert("An error occured. Please try again later.");
                console.log(error);
              });
          }
        })
        .catch(() => {
          console.log("Validation error");
        });
    },
    toggleLoading() {
      this.loading = this.loading ? false : true;
    }
  },
  mounted: function() {
    let year = new Date().getFullYear();
    this.years = [year - 3, year - 2, year - 1, year, year + 1];
  }
};
</script>




// WEBPACK FOOTER //
// src/components/services/sbp/partials/ApplyPermit.vue